import ClienteleQuestion from './ClienteleQuestion.vue';
import ContactInformationQuestion from './ContactInformationQuestion.vue';
import DateQuestion from './DateQuestion.vue';
import HumanResourcesQuestion from './HumanResourcesQuestion.vue';
import LikertQuestion from './LikertQuestion.vue';
import LongTextQuestion from './LongTextQuestion.vue';
import MailingAddressQuestion from './MailingAddressQuestion.vue';
import MultipleChoiceQuestion from './MultipleChoiceQuestion.vue';
import MultipleChoiceDataSetQuestion from './MultipleChoiceDataSetQuestion.vue';
import PointsOfServiceQuestion from './PointsOfServiceQuestion.vue';
import RichTextQuestion from './RichTextQuestion.vue';
import ShortTextQuestion from './ShortTextQuestion.vue';
import SubOrganizationQuestion from './SubOrganizationQuestion.vue';
import TableFormatQuestion from './TableFormatQuestion.vue';
import TextBlockQuestion from './TextBlockQuestion.vue';

export default {
  clientele: ClienteleQuestion,
  contact_information: ContactInformationQuestion,
  date: DateQuestion,
  human_resources: HumanResourcesQuestion,
  likert: LikertQuestion,
  long_text: LongTextQuestion,
  mailing_address: MailingAddressQuestion,
  multiple_choice: MultipleChoiceQuestion,
  multiple_choice_data_set: MultipleChoiceDataSetQuestion,
  points_of_service: PointsOfServiceQuestion,
  rich_text: RichTextQuestion,
  short_text: ShortTextQuestion,
  sub_organization: SubOrganizationQuestion,
  table_format: TableFormatQuestion,
  text_block: TextBlockQuestion,
};
